import Marquee from "react-fast-marquee";
import {
  LOGO_TELE_DOCTOR_GREY,
  LOGO_GREEN_LIGHT_GREY,
  LOGO_YOTTAASYS_GREY,
  LOGO_MAMENTA_GREY,
  LOGO_BEYOND_MEDIA,
  LOGO_BLV,
  LOGO_CARRER_JOURNEY,
  LOGO_MOXXI,
  LOGO_MYNA,
  LOGO_SG_LABS,
  LOGO_SUPPLY_NOW,
  LOGO_XANDER,
} from "../../constants/imageConstants";
import { useHomepageData } from "../../hooks/useHomepageData";

export default function ClientsSection() {
  const { data } = useHomepageData();
  const clientsData = data.clientsSection;

  const getLogoImage = (logoName: string) => {
    switch (logoName) {
      case 'LOGO_TELE_DOCTOR_GREY':
        return LOGO_TELE_DOCTOR_GREY;
      case 'LOGO_GREEN_LIGHT_GREY':
        return LOGO_GREEN_LIGHT_GREY;
      case 'LOGO_YOTTAASYS_GREY':
        return LOGO_YOTTAASYS_GREY;
      case 'LOGO_MAMENTA_GREY':
        return LOGO_MAMENTA_GREY;
      case 'LOGO_BEYOND_MEDIA':
        return LOGO_BEYOND_MEDIA;
      case 'LOGO_BLV':
        return LOGO_BLV;
      case 'LOGO_CARRER_JOURNEY':
        return LOGO_CARRER_JOURNEY;
      case 'LOGO_MOXXI':
        return LOGO_MOXXI;
      case 'LOGO_MYNA':
        return LOGO_MYNA;
      case 'LOGO_SG_LABS':
        return LOGO_SG_LABS;
      case 'LOGO_SUPPLY_NOW':
        return LOGO_SUPPLY_NOW;
      case 'LOGO_XANDER':
        return LOGO_XANDER;
      default:
        return LOGO_TELE_DOCTOR_GREY;
    }
  };

  return (
    <section>
      <h2 className="text-2xl lg:text-[32px] font-medium text-white text-center my-10 tracking-wide">
        {clientsData.title}
      </h2>
      <section className="relative px-4 lg:px-16 py-14 bg-[#182746] overflow-hidden">
        <Marquee autoFill direction="right" className="">
          {clientsData.clients.map((client, index) => (
            <div key={index} className="h-24 lg:h-32 mx-16">
              <img
                src={getLogoImage(client.logo)}
                alt={client.alt}
                className="max-w-full max-h-full object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
        </Marquee>
      </section>
    </section>
  );
}
